export const LOCALE_DOCK_SIZE = 44;
export const LOCALE_DOCK_STORAGE_KEY = "xsou-mobile-locale-dock-v1";
const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export function localeDockBounds(viewport) {
  const left = viewport.left || 0, top = viewport.top || 0;
  const minX = left + Math.max(8, viewport.safeLeft || 0);
  const minY = top + Math.max(8, viewport.safeTop || 0);
  return {
    minX, minY,
    maxX: Math.max(minX, left + viewport.width - LOCALE_DOCK_SIZE - Math.max(8, viewport.safeRight || 0)),
    maxY: Math.max(minY, top + viewport.height - LOCALE_DOCK_SIZE - Math.max(80, (viewport.safeBottom || 0) + 64)),
  };
}

export function clampLocaleDock(position, viewport) {
  const bounds = localeDockBounds(viewport);
  return { x: clamp(position.x, bounds.minX, bounds.maxX), y: clamp(position.y, bounds.minY, bounds.maxY) };
}

export function snapLocaleDock(position, viewport) {
  const bounds = localeDockBounds(viewport), next = clampLocaleDock(position, viewport);
  const edge = next.x < (bounds.minX + bounds.maxX) / 2 ? "left" : "right";
  return { x: edge === "left" ? bounds.minX : bounds.maxX, y: next.y, edge,
    ratio: bounds.maxY === bounds.minY ? 0 : (next.y - bounds.minY) / (bounds.maxY - bounds.minY) };
}

export function restoreLocaleDock(saved, viewport) {
  const bounds = localeDockBounds(viewport);
  const edge = saved?.edge === "left" ? "left" : "right";
  const ratio = Number.isFinite(saved?.ratio) ? clamp(saved.ratio, 0, 1) : .35;
  return { x: edge === "left" ? bounds.minX : bounds.maxX,
    y: bounds.minY + (bounds.maxY - bounds.minY) * ratio, edge, ratio };
}

export function localeDockMenu(position, viewport) {
  const gap = 8, left = viewport.left || 0, top = viewport.top || 0;
  const minX = left + Math.max(gap, viewport.safeLeft || 0), minY = top + Math.max(gap, viewport.safeTop || 0);
  const right = left + viewport.width - Math.max(gap, viewport.safeRight || 0);
  const bottom = top + viewport.height - Math.max(gap, viewport.safeBottom || 0);
  const width = Math.min(232, Math.max(44, right - minX - 16));
  const height = Math.min(160, Math.max(44, bottom - minY));
  const menuX = clamp(position.edge === "left" ? position.x : position.x + LOCALE_DOCK_SIZE - width,
    minX, Math.max(minX, right - width));
  const preferredY = position.y + LOCALE_DOCK_SIZE + 4 + height <= bottom
    ? position.y + LOCALE_DOCK_SIZE + 4 : position.y - height - 4;
  const menuY = clamp(preferredY, minY, Math.max(minY, bottom - height));
  return { left: `${menuX - position.x}px`, top: `${menuY - position.y}px`, right: "auto",
    width: `${width}px`, maxHeight: `${height}px`, overflowY: "auto", boxSizing: "border-box" };
}
